import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import {
    getItemSummaryBidCount,
    getItemSummaryIsTimedPlusAuction,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemCardNavigationTrigger, useTrackRegisterForAuctionPressedAnalytics } from '@/utils/amplitude/analytics';
import { ItemSummary } from '@/types/item/ItemSummary';
import { useAppSelector } from '@/redux/hooks';
import { useCallback, useState } from 'react';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';
import ItemCardPriceRow from '@/components/GridItemCard/Card/components/ItemCardPriceRow/ItemCardPriceRow';
import RegisterLinkOrPrice from '@/components/GridItemCard/Card/CardOptions/TimedPlusItemCard/components/RegisterLinkOrPrice/RegisterLinkOrPrice';

export type PriceComponentExperimentProps = ItemSummary & { position: number };

//Experiment SEAR-769: New similar items CTA experiment
export const PriceComponentExperiment = createInfo<PriceComponentExperimentProps>({
    className: 'line-clamp-0',
    useText: ({ itemId, position, promoted }) => {
        const bidCount = useAppSelector((state) => getItemSummaryBidCount(state, itemId));
        const isTimedPlusAuction = useAppSelector((state) => getItemSummaryIsTimedPlusAuction(state, itemId));

        const [linkHover, setLinkHover] = useState(false);
        const { onNavigateInitiated } = useItemCardNavigation(itemId);
        const trackRegisterForAuctionPressedAnalytics = useTrackRegisterForAuctionPressedAnalytics();

        const enterLinkHoverState = useCallback(() => {
            setLinkHover(true);
        }, []);

        const leaveLinkHoverState = useCallback(() => {
            setLinkHover(false);
        }, []);

        return (
            <div className="relative flex items-center justify-between">
                {isTimedPlusAuction ? (
                    <>
                        <RegisterLinkOrPrice
                            itemId={itemId}
                            linkHover={linkHover}
                            onNavigate={() => {
                                onNavigateInitiated(ItemCardNavigationTrigger.PriceClick, { position, promoted });
                            }}
                            onRegisterForAuctionClicked={() => trackRegisterForAuctionPressedAnalytics()}
                        />
                    </>
                ) : (
                    <>
                        <ItemCardPriceRow
                            isHovered={linkHover}
                            itemId={itemId}
                            onMouseEnter={enterLinkHoverState}
                            onMouseLeave={leaveLinkHoverState}
                            onNavigate={() => {
                                onNavigateInitiated(ItemCardNavigationTrigger.PriceClick, { position, promoted });
                            }}
                            showBidCount={Boolean(bidCount)}
                        />
                    </>
                )}
            </div>
        );
    },
});
